import * as WebFont from "webfontloader";

WebFont.load({
  typekit: {
    id: "jig4hll",
  },
});
